module.exports = __webpack_public_path__ + "static/media/contactlensesColor1.796a6fba.jpg";